export default function focusTimeSlots() {
  const el = document.getElementById('timeSlotsContainer');
  if (el) {
    const options = el.querySelectorAll('input');
    if (options) {
      let found = false;
      options.forEach(option => {
        if (!found && !option.disabled) {
          found = true;
          option.focus();
        }
      });

      if (!found) {
        const cancelBtn = document.getElementById('secondaryButton-1');
        if (cancelBtn) {
          cancelBtn.focus();
        }
      }
    }
    el.focus();
  }
}
